import styled from "styled-components";
import {Text1, Title2} from "../../../styles/components";

export const Container = styled.div`
  width: 100%;
  height: 400px;
  margin: 20vh 0;
  padding: 5vh 3vw;
  color: ${({theme}) => theme.colors.black};

  @media only screen and (${({theme}) => theme.media.extraLarge}) {
    padding: 0 12%;
  }
`

export const Content = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 100px;
`

export const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 60%;
  height: 100%;
`

export const Title = styled(Title2)`
  margin-bottom: 20px;
`

export const Text = styled(Text1)`
  margin-bottom: 50px;
`

export const ImageBlock = styled.div`
  width: 40%;
  height: 100%;
`

export const Image = styled.img`
  width: auto;
  height: 80%;
  float: right;
`

export const ModalBody = styled.div`
  text-align: center;
`